class DisplayPreviewManager {
  private Dictionary: Map<string, MediaStream> = new Map();

  constructor() {}

  getStream(sourceId: string) {
    return this.Dictionary.get(sourceId);
  }

  setStream(sourceId: string, stream: MediaStream) {
    this.Dictionary.set(sourceId, stream);
  }

  destroy(sourceId?: string) {
    if (sourceId) {
      const stream = this.Dictionary.get(sourceId);
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        this.Dictionary.delete(sourceId);
      }
    } else {
      this.Dictionary.forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
      this.Dictionary.clear();
    }
  }
}

export default new DisplayPreviewManager();
